import * as React from "react";

import { useContext } from "react";
import { Button, Grid, Typography, useTheme, Divider } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { AppContext } from "../../contextProviders/AppContext";
import { add, set, addHours, isValid } from "date-fns";
import TimePickerComponent from "./TimePicker";
import FixedReturnTimePickerComponent from "./TimePickerFixedReturnTime";
import DatePickerDateInput from "./DateInput";
import { translation } from "../Dictionary";
import { MdSearch } from "react-icons/md";
import { Box } from "@mui/system";
import { useRef } from "react";

export default function DatePickerFixedTimeframe({
  startDateString,
  disableMultiday,
  endDateString,
  handleSelectedTimeFrame,
  defaultTimeFrame,
  hasError,
  endTimeOk,
  fixedTimeFrames,
  startSliderValue,
  endSliderValue,
  dayStart,
  selectedDateRange,
  handleDateChange,
  startTime,
  endTime,
  SLIDER_STEP,
  setStartTime,
  selectedTimeFrame,
  throttle,
  FEATURE_FIXED_RESERVATION_TIMEFRAME,
  setEndTime,
  handleClickContinue,
  selectedPicker,
  setSelectedPicker,
  contentHeigth,
  getMinimumDate,
  startTimeLabel,
  returnTimeLabel,
}) {
  const {
    mobileViewPort,
    selectedCompany,
    language,
    reservationStart,
    reservationReturn,
  } = useContext(AppContext);
  const theme = useTheme();
  const containerRef = useRef();
  //
  const handleTimeChange = (timeValue) => {
    setStartTime(timeValue);
    setEndTime(addHours(timeValue, selectedTimeFrame));
  };
  const [openCalendar, setopenCalendar] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  // This directs the calendar popper to where it should be,
  // Not the most elegant solution...
  React.useEffect(() => {
    if (containerRef?.current) {
      if (anchorEl === null && selectedPicker === "calendar") {
        setAnchorEl(containerRef.current);
      }
    }
  }, [containerRef, anchorEl, selectedPicker]);

  const handleCloseCalendar = () => {
    if (!reservationStart) {
      setSelectedPicker("startTime");
    } else {
      setSelectedPicker(null);
    }
  };

  return (
    <Box
      sx={{
        justifyContent: "space-evenly",
        alignItems: "center",
        position: "relative",
        transition: "ease-in-out 150ms",
        display: "flex",
        flexDirection: "row",
        width: "60%",
      }}
    >
      <Divider orientation="vertical" flexItem variant="middle" />

      <Box sx={{ width: "25%" }} ref={containerRef}>
        <DatePicker
          minDate={getMinimumDate()}
          label={translation.get(language, "Date label")}
          disabled={!selectedCompany}
          open={selectedPicker === "calendar"}
          disableMaskedInput
          onClose={() => handleCloseCalendar()}
          PaperProps={{
            square: true,
            sx: {
              borderRadius: "17px",
              marginTop: "12px",
            },
          }}
          disablePast
          value={selectedDateRange[0]}
          onChange={(newValue) => {
            handleDateChange(newValue);
          }}
          PopperProps={{
            placement: "bottom-end",
            anchorEl: anchorEl,
          }}
          components={{ PaperContent: RangeShortcutsPanel }}
          componentsProps={{
            paperContent: {
              selectedCompany,
              selectedDateRange,
              theme,
              language,
              endTimeOk,
            },
          }}
          renderInput={(params) => {
            const customProps = {
              ...params,

              focused: selectedPicker === "calendar" ? true : false,
            };

            return (
              <Box onClick={() => setSelectedPicker("calendar")}>
                <DatePickerDateInput
                  contentHeigth={contentHeigth}
                  id={"single-day-picker"}
                  pickerProps={customProps}
                  selectedPicker={selectedPicker}
                  setSelectedPicker={setSelectedPicker}
                />
              </Box>
            );
          }}
        />
      </Box>

      <Divider orientation="vertical" variant="middle" flexItem />

      <Box sx={{ width: "25%" }}>
        <TimePickerComponent
          contentHeigth={contentHeigth}
          selectedPicker={selectedPicker}
          setSelectedPicker={setSelectedPicker}
          hasError={hasError}
          endTimeOk={endTimeOk}
          type={"startTime"}
          selectedDateRange={selectedDateRange}
          title={startTimeLabel}
          dateString={startDateString}
          timeValue={startTime}
          sliderValue={startSliderValue}
          SLIDER_STEP={SLIDER_STEP}
          dayStart={dayStart}
          setStartTime={setStartTime}
          setEndTime={setEndTime}
          selectedTimeFrame={selectedTimeFrame}
          FEATURE_FIXED_RESERVATION_TIMEFRAME={
            FEATURE_FIXED_RESERVATION_TIMEFRAME
          }
          onChange={handleTimeChange}
          onChangeSlider={throttle((_, v) => {
            const minutes = v * SLIDER_STEP;
            const time = add(dayStart, { minutes });
            setStartTime(
              set(selectedDateRange[0], {
                hours: time.getHours(),
                minutes: time.getMinutes(),
              })
            );
            const end = set(selectedDateRange[0], {
              hours: time.getHours(),
              minutes: time.getMinutes(),
            });
            setEndTime(addHours(end, selectedTimeFrame));
            if (FEATURE_FIXED_RESERVATION_TIMEFRAME) {
              setEndTime(addHours(startTime, selectedTimeFrame));
            }
          }, 100)}
        />
      </Box>
      <Divider orientation="vertical" variant="middle" flexItem />
      <Box sx={{ width: "25%" }}>
        {FEATURE_FIXED_RESERVATION_TIMEFRAME && (
          <FixedReturnTimePickerComponent
            contentHeigth={contentHeigth}
            selectedPicker={selectedPicker}
            setSelectedPicker={setSelectedPicker}
            mobileViewPort={mobileViewPort}
            handleSelectedTimeFrame={handleSelectedTimeFrame}
            fixedTimeFrames={fixedTimeFrames}
            defaultTimeFrame={defaultTimeFrame}
            disableMultiday={disableMultiday}
            hasError={hasError}
            endTimeOk={endTimeOk}
            //   open={timeSelectReturnOpen}
            setOpen={setSelectedPicker}
            title={returnTimeLabel}
            type={"returnTime"}
            dateString={endDateString}
            timeValue={startTime}
            startTime={startTime}
            endTime={endTime}
            sliderValue={endSliderValue}
            SLIDER_STEP={SLIDER_STEP}
            dayStart={dayStart}
            setStartTime={setStartTime}
            setEndTime={setEndTime}
            selectedTimeFrame={selectedTimeFrame}
            FEATURE_FIXED_RESERVATION_TIMEFRAME={
              FEATURE_FIXED_RESERVATION_TIMEFRAME
            }
            onChange={(time) => {
              setEndTime(time);
            }}
          />
        )}
        {!FEATURE_FIXED_RESERVATION_TIMEFRAME && (
          <TimePickerComponent
            contentHeigth={contentHeigth}
            selectedPicker={selectedPicker}
            setSelectedPicker={setSelectedPicker}
            hasError={hasError}
            endTimeOk={endTimeOk}
            selectedDateRange={selectedDateRange}
            type={"returnTime"}
            title={returnTimeLabel}
            dateString={endDateString}
            timeValue={endTime}
            sliderValue={endSliderValue}
            SLIDER_STEP={SLIDER_STEP}
            dayStart={dayStart}
            setStartTime={setStartTime}
            setEndTime={setEndTime}
            selectedTimeFrame={selectedTimeFrame}
            FEATURE_FIXED_RESERVATION_TIMEFRAME={
              FEATURE_FIXED_RESERVATION_TIMEFRAME
            }
            onChange={(time) => {
              setEndTime(time);
            }}
            onChangeSlider={throttle((_, v) => {
              const minutes = v * SLIDER_STEP;
              const time = add(dayStart, { minutes });
              setEndTime(
                set(selectedDateRange[1], {
                  hours: time.getHours(),
                  minutes: time.getMinutes(),
                })
              );
              if (FEATURE_FIXED_RESERVATION_TIMEFRAME) {
                setEndTime(addHours(startTime, selectedTimeFrame));
              }
            }, 100)}
          />
        )}
      </Box>
    </Box>
  );
}

const RangeShortcutsPanel = ({
  children,
  selectedCompany,
  selectedDateRange,
  theme,
  language,
  endTimeOk,
}) => {
  const CalendarTitleContent = ({ language }) => {
    const TitleText = () => {
      if (!selectedCompany)
        return translation.get(language, "Error: No company");
      if (selectedCompany && !selectedDateRange[0])
        return translation.get(language, "Select pickup date");
      if (
        selectedCompany &&
        selectedDateRange[0] &&
        !selectedDateRange[1] &&
        !endTimeOk.hasError
      )
        return translation.get(language, "Select return date");

      if (endTimeOk.hasError === true) {
        return endTimeOk.message;
      }

      if (selectedCompany && selectedDateRange[0] && selectedDateRange[1])
        return translation.get(
          language,
          "Reservation fixed timeframe selected"
        );
    };

    const Title = () => (
      <Typography
        variant="body2"
        sx={{ fontSize: "16px", color: theme.palette.primary.secondaryText }}
        align="center"
      >
        <TitleText />
      </Typography>
    );

    const titleBgColor = () => {
      if (endTimeOk.hasError) {
        return theme.palette.warning.light;
      }
      if (selectedCompany && !selectedDateRange[0]) {
        return theme.palette.primary.dateRangeBgFrom;
      }
      if (selectedCompany && selectedDateRange[0] && !selectedDateRange[1]) {
        return theme.palette.primary.dateRangeBgTo;
      }

      if (selectedCompany && selectedDateRange[0] && selectedDateRange[1]) {
        return theme.palette.primary.dateRangeBgComplete;
      }

      return theme.palette.info.main;
    };

    return (
      <Box
        sx={{
          display: "flex",
          bgcolor: titleBgColor(),
          padding: "5px",
          paddingTop: "15px",
          borderTopLeftRadius: "17px",
          borderTopRightRadius: "17px",
          justifyContent: "center",
        }}
      >
        <Title />
      </Box>
    );
  };

  return (
    <React.Fragment>
      <CalendarTitleContent language={language} />

      <Divider orientation="vertical" />

      {children}
    </React.Fragment>
  );
};
